import {notification, Popover, Tooltip} from "antd";
import {useEffect, useRef, useState} from "react";
import {v4} from "uuid";
import EmptyLine from "../EmptyLine";
import CheckCSName from "../CheckCSName";
import {useAppContext} from "../../Context/ProjectContextV2";
import ComparisonCSName from "../ComparisonCSName";

export default function ResultTable({children, style = {}, footer, maxWidth, hideToolbar, enableReactRender, data: row, ...props}) {
    const id = v4();
    const fontFamily = window.location.pathname.includes('/app/report') ? 'Calibri' : 'Segoe UI'
    const fontSize = window.location.pathname.includes('/app/report') ? '11pt' : '9pt'

    const {getSelectedHistory} = useAppContext()

    const [hover, setHover] = useState(false)


    const copy = () => {
        const elTable = document.getElementById(id).getElementsByTagName('table')[0]
        const toolRow = document.getElementById(`tool-row-${id}`)
        if(toolRow) {
            toolRow.style.display = 'none'
        }
        let range, sel;

        if (document.createRange && window.getSelection) {

            range = document.createRange();
            sel = window.getSelection();
            // unselect any element in the page
            sel.removeAllRanges();

            try {
                range.selectNodeContents(elTable);
                sel.addRange(range);
            } catch (e) {
                range.selectNode(elTable);
                sel.addRange(range);
            }

            document.execCommand('copy');
        }

        sel.removeAllRanges();
        notification.success({
            message: 'Table Copied!'
        })
        if(toolRow) {
            toolRow.style.display = 'block'
        }
    }

    const toCSList = (row) => {
        const list = []
        for (const r of row?.data) {
            const cs = ({csName: r.cross_section, csNameVal: r.cross_section})
            if(!list.find(x => x.csName === cs.csName))
                list.push(cs)
        }

        return list
    }

    return (
        <div
            style={{display: 'flex', alignItems: 'end', gap: 4}}
            id={id}
            onMouseMove={(e) => {
                setHover(true)
            }}
            onMouseLeave={(e) => {
                setHover(false)
            }}
        >
            <div style={{maxWidth: maxWidth || '22cm'}}>
                <Tooltip title={(<a style={{color: "white"}} onClick={copy}>Copy</a>)} placement={'topLeft'}>
                    {
                        row?.data?.length > 0 && Object.keys(row.data[0]).includes('cross_section') && (
                            <div style={{fontFamily: fontFamily, fontSize: fontSize}}>
                                <EmptyLine />
                                {
                                    getSelectedHistory()?.type === 'Check' && (
                                        <CheckCSName csNameList={toCSList(row)} />
                                    )
                                }
                                {
                                    getSelectedHistory()?.type === 'Comparison' && (
                                        <ComparisonCSName csNameList={toCSList(row)} />
                                    )
                                }
                                <EmptyLine />
                            </div>
                        )
                    }
                    <table {...props} style={{fontFamily: fontFamily, fontSize: fontSize, ...style}}>
                        {children}
                        <tr>
                            <td>
                                {
                                    footer && (
                                        <>
                                            {footer}
                                        </>
                                    )
                                }
                            </td>
                        </tr>
                    </table>
                </Tooltip>
            </div>
        </div>
    )
}